import stepsTabs from '../config/tabs';
import countries from 'wobi-web-common/dist/assets/js/countries';

const quoteProgressIndexes = {
  destination: 0,
  insured: 1,
  medical: 2,
  medical_extended: 2,
  coverage: 3,
};

const getStepName = (location) => {
  const {pathname} = location;
  return pathname === '/' ? 'details' : pathname.replace('/', '');
};

const getQuoteProgressIndex = (location) => {
  const tabKey = (location.hash || '').replace('#', '');
  return quoteProgressIndexes[tabKey] ?? quoteProgressIndexes.destination;
};

const tabIndexToName = (tabIndex, tabs) => {
  let tabObject = tabs.find(tab => tab.index === tabIndex);
  if (!tabObject) {
    // try to find next tab
    tabObject = tabs.find(tab => tab.index === tabIndex + 1);
  }
  return tabObject ? tabObject.key : false;
};

const getCurrentTabIndex = (location, step) => {
  const tabs = stepsTabs()[step];
  if (!tabs) {
    return false;
  }

  const {hash} = location;
  const tabKey = hash.replace('#', '');
  const tabObject = tabs.find(tab => tabKey === tab.key);
  return tabObject ? tabObject.index : false;
};

const destinationsToNames = (Ids) => {
  let result = '';
  Ids.forEach(value => {
    const destination = countries.find(item => item.value === value);
    result += destination ? result ? ', ' + destination.label : destination.label : '';
  });

  return result;
};

export {
  getCurrentTabIndex,
  getQuoteProgressIndex,
  tabIndexToName,
  getStepName,
  destinationsToNames,
};
